module.exports = __webpack_public_path__ + "img/5.6f1d4dfd.jpg";